import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getMyPermissions } from '@/api/rbac/permission';
import { message } from 'ant-design-vue';

export const usePermissionStore = defineStore('permissions', () => {
  const permissions = ref([]);
  const loading = ref(false);
  
  // 获取用户权限
  const fetchPermissions = async () => {
    loading.value = true;
    try {
      const res = await getMyPermissions();
      console.log(res.data);
      permissions.value = res.data || [];
      // 保存到 localStorage 用于权限按需显示
      localStorage.setItem('userPermissions', permissions.value);
      return permissions.value;
    } catch (error) {
      message.error('加载权限失败');
      console.error('Failed to fetch permissions:', error);
      return [];
    } finally {
      loading.value = false;
    }
  };
  
  // 从 localStorage 获取缓存的权限
  const getPermissionsFromCache = () => {
    try {
      const cached = localStorage.getItem('userPermissions');
      return cached || [];
    } catch (error) {
      console.error('Failed to parse cached permissions:', error);
      return [];
    }
  };
  
  // 清除权限数据
  const clearPermissions = () => {
    permissions.value = [];
    localStorage.removeItem('userPermissions');
  };
  
  return {
    permissions,
    loading,
    fetchPermissions,
    getPermissionsFromCache,
    clearPermissions,
  };
});
